/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import LargePopupRedirect from "../../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import {
  resetUpdateReimbursementAccount,
  updateReimbursementAccount,
  viewAccountDetailR,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import { requestTxnReject } from "../../../../../redux/features/reimbursementRequest";
import { ReimbursementTxnDeniedApproval } from "../../../../../redux/features/reimbursementTransaction";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../../../utils/configurationProvider";
import TEXT from "../../../../../utils/globalText";
import Validation from "../../../../../utils/validation";
import ReimbursementRequestViewAll from "../../../../ReimbursementRequest/ReimbursementRequestViewAll";
import ReimbursementTransactionsViewAll from "../../../../Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";
import ReimbursementBankEdit from "../ReimbursementBankEdit";
import ReimbursementEditConfirm from "../ReimbursementEditConfirm";
import "./index.css";
import {
  bankLookUp,
  getIFSCDetails,
  verifyBankAccount,
  resetBankVerificationError,
  resetBankVerification,
  resetBankLookupData,
} from "../../../../../redux/features/sharedResources/sharedResources";
import SmallPopupWithBulletPoints from "../../../../../components/_utils/CommonSmallPopupWithBulletPoint";

const ReimbursementEditBank = () => {
  const [archivePopup, setArchivePopup] = useState(false);
  const [bankIsPending, setBankIsPending] = useState(false);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [bankIsAchived, setBankIsArchived] = useState(false);
  const [bankIsApproved, setBankIsApproved] = useState(false);
  const [bankSelectedItem, setBankSelectedItem] = useState(null);
  const [bankDisableCreateNext, setBankDisableCreateNext] = useState(false);
  const [bankShutViewAll, setBankShutViewAll] = useState(false);
  const [deniedId, setdeniedId] = useState(null);
  const [bankAccountType, setBankAccountType] = useState({ type: "", id: "" });
  const [bankIsDennied, setBankIsDennied] = useState(false);
  const [bankIsRejected, setBankIsRejected] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [RequestRejectAll, setRequestRejectAll] = useState(false);
  const [pendingTxnReject, setPendingTxnReject] = useState(false);
  const [newBankMessage, setBankNewMessage] = useState(false);
  const [hideBankCreate, setBankHideCreate] = useState(false);
  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [active, setActive] = useState(false);
  const [openEditBankPop, setOpenEditBankPop] = useState(false);
  const [createNewedit, setCreateNewEdit] = useState(false);
  const [bankUnachivedOpenPop, setBankUnachivedOpenPop] = useState(false);
  const [bankAchivedOpenPop, setBankAchivedOpenPop] = useState(false);
  const [verifiedBankKey, setVerifiedBankKey] = useState(null);
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const [ifscLookup, setIfscLookup] = useState(null);
  const ifscDetailsRequestKeyRef = useRef("");
  const currentIfscCodeRef = useRef("");
  const [completedLookupKey, setCompletedLookupKey] = useState("");

  const [bankLookup, setBankLookup] = useState(null);
  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Reimbursement account",
  );
  const [updateActive, setUpdateActive] = useState(false);
  const scrollIt = useRef(null);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    email_id: "",
    pan_no: "",
    bank_name: "",
    contact_no: "",
    legal_name: "",
    old_bank_account: "",
    old_ifsc_code: "",
    name: "",
    gstin_detail: "",
  });

  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const {
    reimbursementAccountUpdateData,
    reimbursementAccountUpdateLoading,
    reimbursementAccountUpdateError,
  } = useSelector((s) => s.ReimburseAccount);

  const { reimbursementTxnViewAllLoading, reimbursementTxnViewAllData } =
    useSelector((state) => state?.reimbursementTransaction);

  const {
    reimbursementRequestViewAllData,
    reimbursementRequestViewAllLoading,
  } = useSelector((state) => state.reimbursementRequest);

  const {
    verifyBankAccountError,
    verifyBankAccountData,
    verifyBankAccountLoading: verifyBankisLoading,
    verifiyBankAccountMessage,
    ifscDetailsError,
    ifscDetailsData,
    bankLookupLoading,
  } = useSelector((state) => state.sharedResources);

  const isBankError =
    verifyBankAccountError || verifyBankAccountData?.status === false;
  const bankVerificationFailureMessage = (() => {
    const errors = verifyBankAccountData?.errors;
    const backendMessage =
      errors?.base?.[0] ||
      errors?.bank_account?.[0] ||
      errors?.ifsc_code?.[0] ||
      errors?.message ||
      (typeof errors === "string" ? errors : null) ||
      verifyBankAccountData?.error ||
      verifyBankAccountData?.message;

    if (verifyBankAccountData?.status === false) return backendMessage;
    if (isBankError && !verifyBankAccountData) {
      return typeof verifiyBankAccountMessage === "string"
        ? verifiyBankAccountMessage
        : verifiyBankAccountMessage?.errors?.base?.[0] ||
            verifiyBankAccountMessage?.errors?.bank_account?.[0];
    }
    return null;
  })();
  const canMarkAsVirtualAccount =
    bankVerificationFailureMessage === "Invalid Bank Account Number / IFSC";
  const isIFSCNotFoundVerificationError =
    typeof bankVerificationFailureMessage === "string" &&
    bankVerificationFailureMessage.trim().toLowerCase() ===
      "not found ifsc code";
  const reimbursementIFSCError =
    ifscDetailsError ||
    ifscDetailsData?.status === false ||
    Boolean(ifscDetailsData?.errors) ||
    isIFSCNotFoundVerificationError;

  const lastVerifyRequestRef = useRef("");

  useEffect(() => {
    const fetchBankData = async () => {
      let response = await dispatch(viewAccountDetailR({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchBankData();
  }, [dispatch, id, navigate]);

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const account = viewAccountDetailData?.reimbursement_accounts?.[0];
      setManualVirtualAccount(account?.virtual_account_type === "manual");
      setPayload({
        ...payload,
        name: account?.name,
        bank_account: account?.bank_acc_no,
        ifsc_code: account?.ifsc_code,
        bank_name: account?.bank_name,
        pan_no: account?.pan_no,
        email_id: account?.email_id,
        contact_no: account?.contact_no,
        legal_name: account?.pan_legal_name,
        old_bank_account: account?.bank_acc_no,
        old_ifsc_code: account?.ifsc_code,
        old_virtual_account_type: account?.virtual_account_type || "",
        gstin_detail: account?.gstin_detail,
      });
    }
  }, [viewAccountDetailData]);
  const handleBackBank = () => {
    if (activeStep === 0) {
      if (createNewedit) {
        setOpenEditBankPop(true);
      } else {
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
        );
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      if (scrollIt.current) {
        scrollIt.current.scrollLeft -= 1024;
      }
    }
  };
  const handleUpdateBank = () => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      handleNextBank();
    } else {
      setArchivePopup(true);
    }
  };

  const createBankAccount = () => {
    setArchivePopup(false);
    if (updateActive) return;

    setUpdateActive(true);
    if (
      viewAccountDetailData?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_transactions === "Y"
    ) {
      setdeniedId(viewAccountDetailData?.reimbursement_accounts?.[0]?.id);
      setPendingTxnReject(true);
    } else if (
      viewAccountDetailData?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_requests === "Y"
    ) {
      setdeniedId(viewAccountDetailData?.reimbursement_accounts?.[0]?.id);
      setRequestRejectAll(true);
    } else {
      dispatch(
        updateReimbursementAccount({
          id: id,
          bank_account: payload.bank_account,
          ifsc_code: payload.ifsc_code,
          virtual: manualVirtualAccount,
          navigate,
        }),
      );
    }
    setUpdateActive(false);
  };

  let newRemId =
    reimbursementAccountUpdateData?.beneficiary_accounts?.[0]?.id || "";

  useEffect(() => {
    if (reimbursementAccountUpdateData?.status === true) {
      const updatedFields = [
        "bank_acc_no",
        "ifsc_code",
        "bank_account_holder_name",
        "virtual_account_type",
      ];
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/bank_edit_success/${newRemId}`,
        {
          state: { updatedFields },
          replace: true,
        },
      );
      dispatch(resetUpdateReimbursementAccount());
    } else if (
      !reimbursementAccountUpdateLoading &&
      reimbursementAccountUpdateData?.status === false
    ) {
      CommonToast({
        text: Object.values(reimbursementAccountUpdateData?.errors)[0][0],
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  }, [reimbursementAccountUpdateData]);

  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    Validation?.ifscRegex?.test(payload?.ifsc_code);

  useEffect(() => {
    if (reimbursementAccountUpdateError || RequestRejectAll) {
      setArchivePopup(false);
    }
  }, [reimbursementAccountUpdateError, RequestRejectAll]);

  const bankLookupKey = JSON.stringify([
    payload.bank_account,
    payload.ifsc_code,
  ]);
  const currentBankLookup =
    bankLookup?.key === bankLookupKey ? bankLookup : null;
  const benebankLookData = currentBankLookup?.data;

  const isBankLookupComplete = Boolean(currentBankLookup);
  const associatedAccounts =
    benebankLookData?.beneficiary_accounts ??
    benebankLookData?.field_force_accounts;
  const hasBankLookupResult = Array.isArray(associatedAccounts);
  const foundAccount = (hasBankLookupResult ? associatedAccounts : []).find(
    (account) =>
      payload.pan_no === account.pan_no &&
      payload.bank_account === account.bank_acc_no &&
      payload.bank_account !== payload.old_bank_account,
  );

  const isBankLinkedAccount = Boolean(foundAccount);

  useEffect(() => {
    if (!foundAccount || activeStep !== 0) return;
    setCurrentAssociate(
      // foundAccount.type_of_account === "field_force"
      //   ? "Field force account"
      //   :
      foundAccount.type_of_account === "reimbursement"
        ? "Reimbursement account"
        : "Beneficiary account",
    );
    setAccActiveInactiveState(
      ["rejected", "blocked", "archived"].includes(foundAccount.approval_status)
        ? "inactive"
        : "active",
    );
  }, [foundAccount, activeStep]);

  const isBankInputValid =
    payload.bank_account?.length >= GlobalConfiguration.accountnormalLength &&
    isIFSCValid;

  const isBankLinkBlocked = isBankLinkedAccount;

  const isBankDetailsChanged =
    payload?.old_bank_account !== payload?.bank_account ||
    payload?.old_ifsc_code !== payload?.ifsc_code;
  const originalManualVirtual =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.virtual_account_type ===
    "manual";
  const originalAccount = viewAccountDetailData?.reimbursement_accounts?.[0];
  const originalVirtualAccount = originalAccount?.virtual_account === "Y";
  const isAutoDetectedVirtual =
    verifyBankAccountData?.verification_details?.[0]?.is_virtual === "Y";
  const isLookupComplete =
    completedLookupKey === bankLookupKey && !bankLookupLoading;
  const requiresAssociationConfirmation =
    isLookupComplete &&
    benebankLookData?.status === true &&
    Array.isArray(associatedAccounts) &&
    associatedAccounts.length > GlobalConfiguration.lengthCheckZero &&
    isBankDetailsChanged &&
    !isBankLinkedAccount &&
    !manualVirtualAccount &&
    !isAutoDetectedVirtual;

  const isCreateStepEnabled =
    !isBankLinkBlocked && !reimbursementAccountUpdateLoading;

  const verifyKey = JSON.stringify([
    payload.bank_account,
    payload.ifsc_code,
    payload.legal_name,
  ]);
  currentIfscCodeRef.current = payload.ifsc_code;
  const verificationDetails = verifyBankAccountData?.verification_details?.[0];
  const hasCompleteVerificationAddress = [
    "branch",
    "city",
    "district",
    "address",
  ].every((field) => Boolean(verificationDetails?.[field]));
  const shouldFetchIFSCDetails =
    manualVirtualAccount ||
    originalVirtualAccount ||
    (originalManualVirtual && !isBankDetailsChanged) ||
    (verifiedBankKey === verifyKey && !hasCompleteVerificationAddress);
  const currentIfscData =
    ifscLookup?.code === payload.ifsc_code ? ifscLookup.data : null;
  useEffect(() => {
    setIfscLookup(null);
    ifscDetailsRequestKeyRef.current = "";
  }, [payload.ifsc_code]);

  useEffect(() => {
    if (!isIFSCValid || !shouldFetchIFSCDetails) return;

    const requestKey = payload.ifsc_code;
    if (ifscDetailsRequestKeyRef.current === requestKey) return;

    ifscDetailsRequestKeyRef.current = requestKey;
    dispatch(
      getIFSCDetails({
        search_string: requestKey,
        page_no: GlobalConfiguration?.lengthCheckOne,
        page_size: GlobalConfiguration?.filterResults,
      }),
    ).then((action) => {
      if (currentIfscCodeRef.current !== requestKey) return;

      const ifscDetails = action.payload?.ifsc_details?.[0];
      if (getIFSCDetails.fulfilled.match(action) && ifscDetails) {
        setIfscLookup({ code: requestKey, data: ifscDetails });
      } else if (ifscDetailsRequestKeyRef.current === requestKey) {
        ifscDetailsRequestKeyRef.current = "";
      }
    });
  }, [
    dispatch,
    isIFSCValid,
    shouldFetchIFSCDetails,
    payload.ifsc_code,
  ]);

  const isNextEnabled =
    isBankInputValid &&
    !verifyBankisLoading &&
    !isBankLinkBlocked &&
    (manualVirtualAccount || (originalManualVirtual && !isBankDetailsChanged)
      ? Boolean(currentIfscData)
      : verifiedBankKey === verifyKey &&
        (!isBankDetailsChanged || isAutoDetectedVirtual || isLookupComplete)) &&
    (!requiresAssociationConfirmation || bankLookupNext) &&
    (payload?.bank_account !== payload?.old_bank_account ||
      payload?.ifsc_code !== payload?.old_ifsc_code ||
      manualVirtualAccount !== originalManualVirtual);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: isNextEnabled,
      stepperText: "Bank details",
    },
    {
      previousText: "Previous",
      nextText: "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextLoaderNeeded: true,
      nextIsLoading: reimbursementAccountUpdateLoading,
      nextIsEnabled: isCreateStepEnabled,
      stepperText: "Confirm and create",
    },
  ];

  const handleNextBank = () => {
    if (isBankLinkBlocked || (activeStep === 0 && !isNextEnabled)) return;

    if (activeStep === 1) {
      const updatedFields = [
        "bank_acc_no",
        "ifsc_code",
        "bank_account_holder_name",
      ];
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/bank_edit_success/${id}`,
        {
          state: { updatedFields },
          replace: true,
        },
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (scrollIt.current) {
        scrollIt.current.scrollLeft += 1024;
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
      // if (event.key === "Tab") {
      // event.preventDefault();
      // }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("RUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (!payload?.bank_account && payload?.ifsc_code) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
    }
    if (
      payload?.bank_account?.length > 0 &&
      payload.bank_account.length < GlobalConfiguration.accountnormalLength
    ) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }

    if (!isBankInputValid) {
      lastVerifyRequestRef.current = "";
      setVerifiedBankKey(null);
      dispatch(resetBankVerification());
      dispatch(resetBankLookupData());
      return;
    }

    if (
      manualVirtualAccount ||
      (originalManualVirtual && !isBankDetailsChanged)
    ) {
      dispatch(resetBankVerificationError());
      return;
    }

    if (services?.includes("RUAccount") || services?.includes("Admin")) {
      if (lastVerifyRequestRef.current !== verifyKey) {
        lastVerifyRequestRef.current = verifyKey;
        setVerifiedBankKey(null);
        dispatch(
          verifyBankAccount({
            ifsc_code: payload?.ifsc_code,
            bank_account: payload?.bank_account,
            legal_name: payload?.legal_name,
            navigate: navigate,
          }),
        ).then((action) => {
          if (lastVerifyRequestRef.current !== verifyKey) return;
          const verificationSucceeded =
            verifyBankAccount.fulfilled.match(action) &&
            action.payload?.status === true;
          setVerifiedBankKey(verificationSucceeded ? verifyKey : null);

          if (verificationSucceeded) {
            dispatch(
              bankLookUp({
                ifsc: payload.ifsc_code,
                bank_account_no: payload.bank_account,
              }),
            ).then((lookupAction) => {
              if (lastVerifyRequestRef.current !== verifyKey) return;
              setCompletedLookupKey(bankLookupKey);
              setBankLookup({
                key: bankLookupKey,
                data: bankLookUp.fulfilled.match(lookupAction)
                  ? lookupAction.payload
                  : null,
              });
            });
          }
        });
      }
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "RUAccount" },
      });
    }
  }, [
    dispatch,
    isBankInputValid,
    verifyKey,
    manualVirtualAccount,
    navigate,
    payload?.ifsc_code,
    payload?.bank_account,
    payload?.legal_name,
    services,
    originalManualVirtual,
    isBankDetailsChanged,
  ]);

  useEffect(() => {
    setBankLookup(null);
    setCompletedLookupKey("");
    setBankLookupNext(false);
  }, [bankLookupKey]);

  useEffect(() => {
    if (
      activeStep !== 0 ||
      manualVirtualAccount ||
      verifyBankAccountError ||
      verifyBankisLoading ||
      verifyBankAccountData?.status !== true ||
      verifyBankAccountData?.verification_details?.[0]?.virtual_account_type !==
        "manual"
    )
      return;

    setManualVirtualAccount(true);
  }, [
    activeStep,
    dispatch,
    manualVirtualAccount,
    verifyBankAccountError,
    verifyBankisLoading,
    verifyBankAccountData,
  ]);

  const handleConfirm = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const handleRejectReimbursementTxn = async (id) => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementTxnViewAllLoading &&
      reimbursementTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transactions.");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        ReimbursementTxnDeniedApproval({ id: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      CommonToast({
        text: "Transactions rejected successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (
        viewAccountDetailData?.reimbursement_accounts?.[0]
          ?.pending_reimbursement_requests === "Y"
      ) {
        setRequestRejectAll(true);
      } else {
        setDeclineReason("");
        const type = "ReimbursementBankEdit";
        dispatch(
          updateReimbursementAccount({
            id: id,
            bank_account: payload.bank_account,
            ifsc_code: payload.ifsc_code,
            virtual: manualVirtualAccount,
            navigate,
            type,
          }),
        );
      }
    } else if (data?.payload === undefined) {
      setDeclineReason("");
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setPendingTxnReject(false);
    setShowLoader(false);
  };

  const handleRejectRequestTxn = async (id) => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementRequestViewAllLoading &&
      reimbursementRequestViewAllData?.requests?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementRequestViewAllData?.requests?.map(
            (data) => data?.request_id,
          )
        : [];

    UniversalRefreshToast("Rejecting requests.");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        requestTxnReject({ request_ids: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementRequest";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      // setshowPopupReject(false);
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      CommonToast({
        text: "Requests rejected successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      const type = "ReimbursementBankEdit";
      await dispatch(
        updateReimbursementAccount({
          id: id,
          bank_account: payload.bank_account,
          ifsc_code: payload.ifsc_code,
          virtual: manualVirtualAccount,
          navigate,
          type,
        }),
      );
      await dispatch(viewAccountDetailR({ id }));
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setRequestRejectAll(false);
    setDeclineReason("");

    setShowLoader(false);
  };

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key !== "Enter" || e.repeat) return;

      // Reject reason popup
      if (showPopupReject) {
        if (
          declineReason &&
          declineReason.length >= GlobalConfiguration?.rejectReasonMinLength
        ) {
          if (
            viewAccountDetailData?.reimbursement_accounts?.[0]
              ?.pending_reimbursement_transactions === "Y"
          ) {
            handleRejectReimbursementTxn(deniedId);
          } else {
            handleRejectRequestTxn(deniedId);
          }
        }
        return;
      }

      // Archive confirmation popup
      if (archivePopup) {
        createBankAccount();
        return;
      }

      // Pending transaction popup
      if (pendingTxnReject) {
        setshowPopupReject(true);
        return;
      }

      // Pending request popup
      if (RequestRejectAll) {
        if (declineReason === "") {
          setshowPopupReject(true);
        } else {
          handleRejectRequestTxn(deniedId);
        }
        return;
      }

      // Main screen actions
      if (
        activeStep === GlobalConfiguration?.lengthCheckZero &&
        isNextEnabled
      ) {
        handleUpdateBank();
        return;
      }

      if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        isCreateStepEnabled
      ) {
        handleUpdateBank();
      }
    },
    [
      activeStep,
      archivePopup,
      pendingTxnReject,
      RequestRejectAll,
      showPopupReject,
      declineReason,
      deniedId,
      isNextEnabled,
      isCreateStepEnabled,
      createBankAccount,
      handleUpdateBank,
      viewAccountDetailData,
    ],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);

    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);

  return (
    <div
      className="edit_bank_con_main !h-screen"
      style={{
        overflowY: openEditBankPop ? "hidden" : "hidden",
        height:
          openEditBankPop || bankUnachivedOpenPop || bankAchivedOpenPop
            ? "var(--full-height)"
            : "",
      }}
    >
      <div className="hidden Qsmd:block min-h-navbar-breadcrumb-height"></div>
      {pendingTxnReject && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Pending transactions found"
              headersubtext="The following transactions are linked and need to be rejected before archiving this account."
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                setPendingTxnReject(false);
              }}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              bottomHeaderTextNeed={true}
              bottomHeaderText={`To update the account, please reject the transactions listed above by clicking the "Reject all" button.`}
              isbottomSectionneed={true}
              btnText={"Reject all"}
              confirmbtnrequired={true}
              handleFunction={() => {
                const hasAccess = services?.find(
                  (service) =>
                    service === "AReimbursementTxn" || service === "Admin",
                );
                if (!hasAccess) return;
                setshowPopupReject(true);
              }}
              isLoaderNeeded={true}
              isLoading={showLoader ? true : false}
              enabledBgColor={"var(--negative-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              inActiveVariantNeeded
              fullWidthRequired={false}
              isDisabled={
                services?.find((service) => service === "AReimbursementTxn") ===
                undefined
              }
              disabledTextColor={"var(--text-primary)"}
              disabledBgColor={"var(--text-disabled)"}
            >
              <ReimbursementTransactionsViewAll
                type={"reimburse_txnViewAll_popup"}
                alert={"alertpopup"}
                flow={"reimburse_txnViewAll_popup_reject"}
                closeRejectAllTxn={() => {
                  setPendingTxnReject(false);
                }}
                TxnHistoryid={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.id
                }
                TxnHistoryAccountName={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.name
                }
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {RequestRejectAll && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Pending requests found"
              headersubtext="The following requests are linked and need to be rejected before archiving this account."
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              fullviewisDisabled={false}
              fullviewenabledTextColor="var(--text-primary)"
              fullviewenabledBgColor="var(--primary-nav)"
              fullviewhoverOption="white"
              fullviewicon={ICONS?.REDIRECT}
              fullviewdisabledBgColor="var(--text-disabled)"
              closeiconbtnType="button"
              closeiconhandleFunction={() => {
                setRequestRejectAll(false);
              }}
              closeiconisDisabled={false}
              closeiconenabledBgColor="var(--primary-nav)"
              closeicondisabledBgColor="var(--text-disabled)"
              closeiconhoverOption="white"
              closeicon={ICONS?.CLOSE}
              bottomHeaderTextNeed={true}
              bottomHeaderText={
                "To reject the account, please reject the requests listed above by clicking the “Reject all” button. The requests will get rejected with the provided rejected reason."
              }
              isbottomSectionneed={true}
              btnText={"Reject all"}
              confirmbtnrequired={true}
              handleFunction={() => {
                const hasAccess = services?.find(
                  (service) =>
                    service === "AReimbursementTxn" || service === "Admin",
                );
                if (!hasAccess) return;
                if (declineReason === "") {
                  setshowPopupReject(true);
                } else {
                  handleRejectRequestTxn(deniedId);
                }
              }}
              enabledBgColor={"var(--negative-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              inActiveVariantNeeded
              fullWidthRequired={false}
              isDisabled={
                services?.find(
                  (service) => service === "AReimbursementRequest",
                ) === undefined
              }
              disabledTextColor={"var(--text-primary)"}
              disabledBgColor={"var(--text-disabled)"}
            >
              <ReimbursementRequestViewAll
                type={"requestViewallPopup"}
                flow={"RequestRejectAll"}
                TxnHistoryid={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.id
                }
                TxnHistoryAccountName={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.name
                }
                closeReimburseTxnDetailsModal={() => {
                  setRequestRejectAll(false);
                }}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle={
              pendingTxnReject
                ? `Reject ${
                    reimbursementTxnViewAllData?.transactions?.length === GlobalConfiguration.lengthCheckOne
                      ? "transaction"
                      : "transactions"
                  }`
                : `Reject ${
                    reimbursementRequestViewAllData?.requests?.length === GlobalConfiguration.lengthCheckOne
                      ? "request"
                      : "requests"
                  }`
            }
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            subtextwithbullet="Y"
            bulletPoints={
              pendingTxnReject
                ? [
                    "Transaction will be rejected, and distribution will not be initiated.",
                    "Transaction cannot be edited.",
                  ]
                : [
                    "Once rejected, a new request should be created and no transaction will be initiated.",
                  ]
            }
            noteColor="text-secondary"
            inputPlaceholder="Reason"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputIsDisabled={showLoader ? true : false}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setDeclineReason("");
                setshowPopupReject(false);
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (
                viewAccountDetailData?.reimbursement_accounts?.[0]
                  ?.pending_reimbursement_transactions === "Y"
              ) {
                handleRejectReimbursementTxn(deniedId);
              } else {
                handleRejectRequestTxn(deniedId);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration?.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {openEditBankPop && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Confirm leaving this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will not update the changes made."
            btnOneText="Stay"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenEditBankPop(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {archivePopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopupWithBulletPoints
            headerTitle={"Account update"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            bulletPoints={[
              "The old account will be archived and become inactive.",
              "The new account will be created as an active beneficiary account.",
              "Inactive accounts cannot be used to create transactions.",
            ]}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setArchivePopup(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoIsLoaderNeeded
            btnTwoIsLoading={reimbursementAccountUpdateLoading}
            btnTwoBtnType="button"
            btnTwoHandleFunction={createBankAccount}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="main_edit_stepper_div z-z-index-header">
        <div className="w-full Qsmd:w-std-width relative min-h-stepper-height">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleUpdateBank}
            handleBackwardAction={handleBackBank}
            dataArray={dataArray}
          />
        </div>
      </div>

      <div className="block Qsmd:hidden w-full">
        <TopNavComponent
          isFormattingNotRequired
          topNavHeader={"Reimbursement account"}
          topNavSubText="Bank details"
        />
      </div>
      <div
        className="edit_bank_details_all no-scrollbar Qsmd:pt-padding-lg pt-padding-base mt-margin-md Qsmd:mt-margin-base flex-col px-padding-md Qlg:px-padding-base"
        ref={scrollIt}
      >
        {activeStep === 0 ? (
          <ReimbursementBankEdit
            manualVirtualAccount={manualVirtualAccount}
            setManualVirtualAccount={setManualVirtualAccount}
            ifscData={currentIfscData}
            originalManualVirtual={originalManualVirtual}
            bankIsAchived={bankIsAchived}
            handleNextBank={handleNextBank}
            setBankIsArchived={setBankIsArchived}
            setBankIsApproved={setBankIsApproved}
            bankIsApproved={bankIsApproved}
            bankSelectedItem={bankSelectedItem}
            setBankSelectedItem={setBankSelectedItem}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            setBankIsPending={setBankIsPending}
            bankIsPending={bankIsPending}
            bankIsDennied={bankIsDennied}
            bankIsRejected={bankIsRejected}
            setBankIsDennied={setBankIsDennied}
            setBankIsRejected={setBankIsRejected}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            payload={payload}
            setPayload={setPayload}
            setBankShutViewAll={setBankShutViewAll}
            bankShutViewAll={bankShutViewAll}
            setBankDisableCreateNext={setBankDisableCreateNext}
            bankDisableCreateNext={bankDisableCreateNext}
            bankAccountType={bankAccountType}
            setBankAccountType={setBankAccountType}
            verifiedBank={true}
            verifyBankisLoading={verifyBankisLoading}
            active={active}
            setActive={setActive}
            newBankMessage={newBankMessage}
            setBankNewMessage={setBankNewMessage}
            hideBankBlock={hideBankBlock}
            setBankHideBlock={setBankHideBlock}
            hideBankCreate={hideBankCreate}
            setBankHideCreate={setBankHideCreate}
            previousBankID={id}
            isBankLinkedAccount={isBankLinkedAccount}
            createNewedit={createNewedit}
            setCreateNewEdit={setCreateNewEdit}
            bankUnachivedOpenPop={bankUnachivedOpenPop}
            setBankUnachivedOpenPop={setBankUnachivedOpenPop}
            bankAchivedOpenPop={bankAchivedOpenPop}
            setBankAchivedOpenPop={setBankAchivedOpenPop}
            benebankLookData={benebankLookData}
            isBankLookupComplete={isBankLookupComplete}
            hasAssociationResult={
              isBankInputValid &&
              isBankLookupComplete &&
              Boolean(benebankLookData)
            }
            isIFSCValid={isIFSCValid}
            canMarkAsVirtualAccount={canMarkAsVirtualAccount}
            ownerAccIfscError={reimbursementIFSCError}
            accActiveInactiveState={accActiveInactiveState}
            setAccActiveInactiveState={setAccActiveInactiveState}
            currentAssociate={currentAssociate}
            setCurrentAssociate={setCurrentAssociate}
            id={id}
          />
        ) : (
          <ReimbursementEditConfirm
            manualVirtualAccount={manualVirtualAccount}
            ifscData={currentIfscData}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            payload={payload}
          />
        )}
        <div className="min-h-pagination-height"></div>
      </div>
      <div className="Qsmd:hidden block min-h-pagination-height"></div>
    </div>
  );
};

export default ReimbursementEditBank;
